import { Box } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import { OEMAdv } from "../../../src/constants/VehicleAdvantages";
import { oemVehicleContentData } from "../../../src/constants/VehiclesContent";
import { blogData } from "../../../src/constants/oemBlogData";
import { oemPriceList } from "../../../src/constants/oemPriceInfo";
import {
  BrandLogos,
  newVehicles,
  vehicles,
} from "../../../src/constants/vehicleData";
import { imagesWEBP } from "../../../src/constants/webpImages";
import { MemoizedFooter } from "../../../src/layouts/footer";
import { MemoizedHeader } from "../../../src/layouts/header";
import FullscreenDrawer from "../../../src/modules/Home/HomePageRevamp/VehicleSlideDrawer";
import MemoizedTopBanner from "../../../src/modules/Vehicles/Banner/BannerGeneric";
import BrandLogoTile from "../../../src/modules/Vehicles/Banner/BrandLogoTile";
import BulletPoints from "../../../src/modules/Vehicles/Banner/BulletPoints";
import HeaderDesc from "../../../src/modules/Vehicles/Banner/HeaderDesc";
import VehiclesAdv from "../../../src/modules/Vehicles/Banner/VehiclesAdv";
import MemoizedBrandBlogList from "../../../src/modules/Vehicles/BrandBlogList";
import MemoizedBrandDealerNear from "../../../src/modules/Vehicles/BrandDealerNear";
import MemoizedBrandPromises from "../../../src/modules/Vehicles/BrandPromises";
import MemoizedBrandVehicleLoan from "../../../src/modules/Vehicles/BrandVehicleLoan";
import MemoizedBrandVehicleVariant from "../../../src/modules/Vehicles/BrandVehicleVariant";
import { MemoizedBrandVehiclesListing } from "../../../src/modules/Vehicles/BrandVehicleslisting";
import MemoizedVehiclePriceList from "../../../src/modules/Vehicles/TableData/VehiclePriceList";
import MemoizedSearchHeader from "../../../src/modules/Vehicles/searchHeader";
import { sendAnalytics } from "../../../src/utils/analyticsCommon";

import LoanFormPopupV2 from "../../../src/Drawer/LoanFormPopupV2";
import { MemoizedConnectDrawer } from "../../../src/Drawer/connectDrawer";
import FAQ from "../../../src/SDK/FAQ/faq";
import { brandFAQs } from "../../../src/constants/brandFaqs";
import { oemPromiseList } from "../../../src/constants/oemPromises";
import { OSMFaqSchema } from "../../../src/constants/structuredFAQ";
import { primary } from "../../../src/constants/theme";
import WhatsAppFloater from "../../../src/modules/Brand/WhatAppFloater";
import BookEVConsultationForm from "../../../src/modules/Home/BookEVconsult/bookEVConsultation";
import QlDrawerComponent from "../../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import { GAURANTEED_LOAN_EMI_CARD_DATA } from "../../../src/constants/electricCommericalVehicle/Eular/Eular.js";

export default function VehicleBrand({ brand, BrandVehiclesData, BrandLogos }) {
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_${brand}` },
      "en"
    );
  }, [brand]);

  //We need to add SEO Meta info later

  return (
    <>
      <Head>
        <title>
          OSM Electric Auto Price, Features, Test Drives, EMI & Battery Capacity
        </title>
        <meta
          name="description"
          content={`Explore OSM Electric Auto Price, features, test drives, EMI options & battery capacity. Buy OSM Electric vehicles from Turno today at best prices.`}
        />
        <meta
          name="keywords"
          content={`osm electric auto,osm electric three wheeler,osm electric vehicles,osm three wheeler,osm electric auto price
          `}
        />
        <meta name="author" content="Turno" />
        <meta
          name="url"
          content={`https://www.turno.club/electric-commercial-vehicles/${brand}`}
        />
        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link
          rel="canonical"
          href={`https://www.turno.club/electric-commercial-vehicles/${brand}`}
        />
        <link rel="icon" href="/favicon.png" />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(OSMFaqSchema),
          }}
        />
      </Head>

      <body>
        <Box>
          {/* Main component  */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader />
          </Box>
          <FullscreenDrawer />
          <LoanFormPopupV2 />
          <QlDrawerComponent />

          <MemoizedSearchHeader />
          <MemoizedTopBanner
            bannerData={{
              desktopImg: imagesWEBP?.osm?.osmDesktopBanner,
              mobileImg: imagesWEBP?.osmBanner,
              alt: "OSM electric auto banner",
            }}
          />
          <Box sx={{ display: { sm: "block", md: "none", lg: "none" } }}>
            {" "}
            <BookEVConsultationForm />
          </Box>

          <MemoizedBrandVehiclesListing
            vehicleLocalData={BrandVehiclesData}
            headerInfo={"OSM Electric Auto"}
            description={`Turno invites you to embrace the future of sustainable transportation with OSM Electric Auto. Explore our range of OSM electric auto models, including the OSM Rage+ and OSM Rage+ Frost, and experience the eco-friendly and efficient mobility solutions they offer. Join us in driving towards a greener tomorrow with OSM Electric Vehicles available at Turno.
`}
            ctaText={"Get On Road Price "}
          />
          <MemoizedVehiclePriceList
            priceData={{
              priceList: oemPriceList?.osm,
              headerInfo: "OSM Electric Auto Price List in India 2024",
              description: `Discover the price range of OSM electric auto, offering sustainable and cost-effective transportation solutions for various business requirements.
              OSM electric trucks are designed to revolutionise the commercial transportation sector with their efficiency, reliability, and eco-friendliness. Below is a table showcasing the OSM electric truck models along with their respective price ranges.
              `,
            }}
          />

          <MemoizedBrandPromises
            promisesData={{
              headerInfo: "Why OSM Electric Vehicles from Turno:",
              promiseList: oemPromiseList?.osm,
            }}
          />

          <BrandLogoTile
            BrandLogos={BrandLogos}
            brand={brand}
            title={"Available Brands"}
          />

          <HeaderDesc
            heading="Advantages of OSM Electric Vehicles?"
            HeadingTag="h2"
            subText="Choose OSM Electric Vehicles for their business-friendliness, advanced technology, and practicality. Turno proudly offers the renowned OSM brand. They have,"
          />
          <VehiclesAdv listItems={OEMAdv?.osm} />
          <MemoizedBrandVehicleLoan headerInfo="OSM EV loan" cardDetails={GAURANTEED_LOAN_EMI_CARD_DATA}/>

          <HeaderDesc
            heading="Highlights of OSM EV Auto:"
            HeadingTag="h2"
            subText="OSM EV Auto is a zero-emission vehicle with a long battery life that can last up to 100 kilometres on a single charge. It features regenerative braking, which helps to conserve energy and extend the battery life. OSM EV Auto is also easy to operate and offers a comfortable ride, making it a great choice for those who are looking for an eco-friendly vehicle that won't break the bank.

"
          />

          <MemoizedBrandBlogList
            blogData={{
              data: blogData?.osm,
              headerInfo: "OSM Goods Electric 3 Wheelers Blogs",
            }}
          />

          <HeaderDesc
            heading="About OSM Electric Auto:"
            subText={`OSM offers a wide range of electric vehicles, including three-wheelers, passenger vehicles, and commercial vehicles. The company's vehicles are designed to be both eco-friendly and affordable, and they are well-suited for use in urban and rural areas.
          <br/>
          <br/>

OSM has a strong focus on innovation, and the company is constantly developing new technologies to improve the performance and efficiency of its vehicles. OSM is also committed to providing excellent customer service, and the company has a nationwide network of dealerships and service centres.
`}
          />

          <BulletPoints ContentData={oemVehicleContentData?.osm?.USPs} />
          {/* Electric Vehicle by OEM */}

          <MemoizedBrandVehicleVariant
            brandVariantData={{
              headerInfo: "Electric Commercial Vehicles by OSM",
              description:
                "OSM Electric EV has a range of vehicles that are designed to meet the needs of different users. Here are some of the vehicles offered by OSM Electric EV:",
              variantList: oemPriceList?.osm,
            }}
          />
          {/* Oem 3 wheeler Highlight */}
          <BulletPoints ContentData={oemVehicleContentData?.osm?.Insights} />
          <MemoizedBrandDealerNear
            BannerDealerData={{
              headerInfo: "OSM EV Dealers Near Me:",
              description: `Thanks to the expansion in the company’s reach and popularity, OSM is rapidly making its presence felt across India. As more people are leaning towards OSM’s high-quality mobility solutions that offer excellent value for money, Turno brings you this exceptional range of Electric Trucks at affordable prices. If you want to purchase OSM electric vehicles you can always head to Turno.
`,
              desktopImg: imagesWEBP?.locationBanner,
              mobileImg: imagesWEBP?.locationBanner,
              alt: "OSM electric auto",
            }}
          />

          <Box
            style={{
              // display: "flex",
              // alignItems: "center",
              justifyContent: "center",
              paddingTop: "20px",
              padding: "20px 8% 20px 8%",

              width: "100% !important",
              background: primary?.lightGrey,
            }}
          >
            <FAQ
              faqList={brandFAQs?.osm}
              showItems={brandFAQs?.osm?.length}
              headText={"FAQs on OSM Electric Auto"}
            />
          </Box>
          <WhatsAppFloater />
          <MemoizedConnectDrawer
            heading={"Talk to Us"}
            subHeading={
              "We help you find the best vehicle for your business with affordable financing. Connect with us now."
            }
            ctaText={"Call us"}
          />
          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
}

export const getStaticProps = (context) => {
  const brand = "OSM";
  let allvehicles = [...vehicles, ...newVehicles];
  let BrandVehiclesData = allvehicles?.filter((vehicle) => {
    return vehicle?.brand?.toLocaleLowerCase() === brand?.toLocaleLowerCase();
  });
  return {
    props: { brand, BrandVehiclesData, BrandLogos },
  };
};
